import React from "react";

const PlayThree = ({width='18',height='22'}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 11L0 21.3923V0.607696L18 11Z" fill="currentColor" />
    </svg>
  );
};

export default PlayThree;
